export const GET_ARTISTS = 'app/Artists/GET_ARTISTS';
export const GET_PROFILE_REPERTOIRE = 'app/Artists/GET_PROFILE_REPERTOIRE';
